<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <b-card-group>
            <b-card no-body class="p-12  transparent-bg">
              <b-card-body id="login-form">
                <b-form>
                  <h1 class="text-light">{{$t('enduser_reset_password.title')}} <img class="navbar-brand-full" src="img/innoknight/logo.png" width="37" height="48" alt="InnoKnight"></h1>
                  <p class="text-light">{{$t('enduser_reset_password.description')}}</p>

                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="fa fa-at"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="email" 
                                  class="form-control" 
                                  :placeholder="$t('enduser_reset_password.email_placeholder')" 
                                  v-model.lazy.trim="$v.username.$model"
                                  v-focus
                                  :state="chkState('username')"
                                  aria-describedby="invalidEmailFeedback"/>
                    <b-form-invalid-feedback id="invalidEmailFeedback">{{$t('enduser_reset_password.invalidEmailFeedback')}}</b-form-invalid-feedback>
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="fa fa-key"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="password" 
                                  class="form-control" 
                                  :placeholder="$t('enduser_reset_password.password_placeholder')" 
                                  v-model.lazy.trim="$v.password.$model"
                                  :state="chkState('password')"
                                  aria-describedby="invalidPasswordFeedback"/>
                    <b-form-invalid-feedback id="invalidPasswordFeedback">{{$t('enduser_reset_password.invalidPasswordFeedback', { min: $v.password.$params.minLength.min})}}</b-form-invalid-feedback>
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="fa fa-key"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="password" 
                                  class="form-control" 
                                  :placeholder="$t('enduser_reset_password.repeat_password_placeholder')"
                                  v-model.lazy.trim="$v.repeatPassword.$model"
                                  :state="chkState('repeatPassword')"
                                  aria-describedby="invalidPassword2Feedback"/>
                    <b-form-invalid-feedback id="invalidPassword2Feedback">{{$t('enduser_reset_password.invalidPassword2Feedback')}}</b-form-invalid-feedback>
                  </b-input-group>

                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="fa fa-grav"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="text" 
                                  class="form-control" 
                                  :placeholder="$t('enduser_reset_password.token_placeholder')"
                                  v-model.lazy.trim="$v.token.$model"
                                  :state="chkState('token')"
                                  aria-describedby="invalidTokenFeedback"/>
                    <b-form-invalid-feedback id="invalidTokenFeedback">{{$t('enduser_reset_password.invalidTokenFeedback')}}</b-form-invalid-feedback>
                    <b-button variant="success" :disabled="!($v.username.mail_or_phone&&$v.username.required)" class="px-4" @click="getToken()">{{$t('enduser_reset_password.getToken')}}</b-button>
                    <span class="d-inline-block w-100 text-warning" v-if="is_get_token_clicked">{{$t('enduser_reset_password.getTokenRemarks')}}</span>
                  </b-input-group>

                  <b-row>
                    <b-col cols="12">
                      <b-button variant="primary" :disabled="!$v.token.required||resetpassword_processing" class="px-4 w-100" @click="submit()">{{$t('enduser_reset_password.submit')}}</b-button>
                      <span class="text-center d-inline-block w-100 text-warning" v-if="resetpassword_processing">{{$t('enduser_reset_password.resetpassword_processing')}}</span>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12" class="text-center text-light" style="padding-top:1.2rem;">
                      <h5 class="d-inline pointer" @click="gotoLogin()"><i class="fa fa-sign-in"></i>{{$t('enduser_reset_password.gotoLogin')}}&nbsp;&nbsp;</h5>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col>
                      <div class="mt-3 ml-auto text-white pri-info-declaration text-center">
                        <span v-html="PrivacyPolicy"></span> 
                      </div>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col>
                      <div class="ml-auto text-white pri-info-declaration text-center">
                        {{$t('innoknight') + '©' + thisyear}}
                      </div>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { required, minLength, between, email, sameAs, maxLength } from 'vuelidate/lib/validators'
import VueNotifications from 'vue-notifications'
import config from '@/config/global'
import notifications from '@/config/notifications'

const encrypt  = config.encrypt;
const decrypt  = config.decrypt;
const api_root = config.api_root;

const mail_or_phone = (value) => {
  const phoneRegex = /^09\d{8}$/;
  //const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const emailRegex = /^(?!.*\.\.)(?!\.)(?!.*\.$)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return (phoneRegex.test(value || '') || emailRegex.test(value || ''));
};

const generateRandomToken = () => {
  // 使用 36 進位，並串接兩個隨機數來增加長度
  const part1 = Math.random().toString(36).slice(2).toUpperCase();
  const part2 = Math.random().toString(36).slice(2).toUpperCase();
  const part3 = Math.random().toString(36).slice(2).toUpperCase();
  return `${part1}${part2}${part3}`; 
};

export default {
  name: 'Login',
  
  notifications,

  beforeMount() {
  },//eo beforeMount

  data() {
    const this_year = new Date();

    return {
      username:             '',
      password:             '',
      repeatPassword:       '',
      name:                 '',
      phone:                '',
      token:                '',
      captcha_action:       '',
      show_capthca:         config.show_capthca,
      captcha_action:       config.captcha_action,
      submit_btn_disabled:  true,
      is_get_token_clicked: false,
      thisyear: this_year.getFullYear(),
      footer: config.footer,
      resetpassword_processing: false
    };
  },//eo data

  computed: {
    PrivacyPolicy() {
      const link = `<a href="https://law.moj.gov.tw/LawClass/LawAll.aspx?PCode=I0050021" target="_blank">${this.$t('personal_data_protection_act')}</a>`;
      return this.$t('privacy_policy_message', { link });
    }
  },//eo computed

  methods: {
    submit(){
      // console.info('submit');return;
      
      let app = this;

      this.$v.$touch();

      if (this.$v.$invalid) {
        this.showError({message:this.$t('enduser_reset_password.error.incorrect_input'), timeout: 15000});
        return false;
      }

      grecaptcha.execute(config.captcha_key, {action: 'resetpasswordform'})
      .then(function(ggtoken) {

        let username = app.username;
        let password = app.password;
        let phone    = app.phone;
        let name     = app.name;
        let token    = app.token;

        app.resetpassword_processing = true;
        let action = `${api_root}/enduser/resetpassword`;
        let params   = {
          keyset: 'mqtt',
          form: encodeURIComponent(encrypt(JSON.stringify({
            username,
            password,
            token
          }))),
          frontend:location.origin,
          ggtoken
        };
        fetch(action, {
          method: 'POST',
          headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + generateRandomToken()
          },
          body: JSON.stringify(params)
        }).then(res => res.json()).then(result => {
          if(!result.success){
            if(result.message === 'USER_NOT_EXIST') {
              app.showWarn({
                message: app.$t('enduser_reset_password.warning.user_not_exist', { username }),
                timeout: 15000
              });
            } else if(result.message === 'RECAPTCHA_FAIL'){
              app.showError({
                message: app.$t('enduser_reset_password.error.recaptcha_fail'),
                timeout: 15000
              });
            } else if(result.message === 'INVALID_TOKEN'){
              app.showError({
                message: app.$t('enduser_reset_password.error.invalid_token'),
                timeout: 15000
              });
            } else {
              app.showError({
                message: app.$t('enduser_reset_password.error.reset_others_error'),
                timeout: 15000
              });
            }
          } else {
            app.showSuccess({
              message: app.$t('enduser_reset_password.reset_password_success'),
              timeout: 5000
            });
            app.$router.push('/');
          }
          app.resetpassword_processing = false;
        }).catch(error => {
          app.showError({
            message: app.$t('enduser_reset_password.reset_password_fail') + error,
            timeout: 15000
          });
          app.resetpassword_processing = false;
        });
      });
    },//eo submit
    chkState(val) {
      const field = this.$v[val];
      return !field.$dirty || !field.$invalid;
    },//eo chkState
    gotoLogin() {
      this.$router.push('/');
    },//eo gotoLogin
    gotoResetPassword(){
      this.$router.push('/amnesia');
    },//eo gotoResetPassword
    getToken(){
      let app = this;

      if(app.is_get_token_clicked){
        app.showWarn({
          message: this.$t('enduser_reset_password.warning.wait_token_get')
        });
        return false;
      }

      app.is_get_token_clicked = true;

      let _cc = setTimeout(() => {
        app.is_get_token_clicked = false;
      }, 30000);

      grecaptcha.execute(config.captcha_key, {action: 'resetpassword'})
      .then(function(ggtoken) {

        let username = app.username;
        let action   = `${api_root}/enduser/resetpassword_send_token`;
        let params   = {
          keyset: 'mqtt',
          username: encodeURIComponent(encrypt(JSON.stringify({username}))),
          ggtoken,
        };

        fetch(action, {
          method: 'POST',
          headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + generateRandomToken()
          },
          body: JSON.stringify(params)
        }).then(res => res.json()).then(result => {
          if(!result.success){
            if(result.message === 'USER_NOT_EXIST') {
              app.showWarn({
                message: app.$t('enduser_reset_password.warning.user_not_exist', { username }),
                timeout: 15000
              });
            } else if(result.message === 'RECAPTCHA_FAIL'){
              app.showError({
                message: app.$t('enduser_reset_password.error.recaptcha_fail'),
                timeout: 15000
              });
            } else {
              app.showError({
                message: app.$t('enduser_reset_password.error.token_others_error'),
                timeout: 15000
              });
            }
            clearTimeout(_cc);
            app.is_get_token_clicked = false;
          } else {
            let message = app.$t('enduser_reset_password.token_sent', { username });
            if(username.indexOf('@') !== -1) { //email login user.
              message += app.$t('enduser_reset_password.check_email');
            } else { //phone login user
              if(result.to_email) {
                //console.info('result.to_email:', result.to_email);
                message = app.$t('enduser_reset_password.token_sent', { username : result.to_email}) + app.$t('enduser_reset_password.check_email');;
              } else {
                message += app.$t('enduser_reset_password.check_phone');
              }
            }
            app.showSuccess({
              message,
              timeout: 15000
            });
          }
        }).catch(error => {
        }); 
      });

    },//eo getToken
  },//eo methods

  validations: {
    username: {
      mail_or_phone,
      required,
      minLength: minLength(5),
    },
    password: {
      required,
      minLength: minLength(5),
    },
    repeatPassword: {
      required,
      minLength: minLength(5),
      sameAs: sameAs('password')
    },
    token: {
      required,
      minLength: minLength(6)
    },
  }//eo validations
}
</script>

<style>
.card-body{
  padding: 1.25rem !important;
}
.pointer{
  cursor: pointer;
}
.grecaptcha-badge{
  display: none;
}
</style>
